(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("jquery.lsxemojipicker", [], factory);
	else if(typeof exports === 'object')
		exports["jquery.lsxemojipicker"] = factory();
	else
		root["jquery.lsxemojipicker"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition